import { useTranslation } from 'react-i18next'
import { useEffect, useState } from 'react'

import { primaryButtonStyle } from '../styles/buttonStyles'
import {
  footerModalActionsStyle,
  footerModalBoxStyle,
  footerModalOverlayStyle
} from '../styles/footerModalStyles'

const FaqModal = ({ open, onClose }) => {
  const { t } = useTranslation()

  const [hoverBtn, setHoverBtn] = useState(null)
  const [pressedBtn, setPressedBtn] = useState(null)
  const [openIndex, setOpenIndex] = useState(null)

  useEffect(() => {
    if (!open) return

    const handleKeyDown = (e) => {
      if (e.key === 'Escape') onClose()
    }

    window.addEventListener('keydown', handleKeyDown)

    return () => {
      window.removeEventListener('keydown', handleKeyDown)
    }
  }, [open, onClose])

  if (!open) return null

  const faq = [
    { q: t('FAQ_Q0'), a: t('FAQ_A0') },
    { q: t('FAQ_Q1'), a: t('FAQ_A1') },
    { q: t('FAQ_Q2'), a: t('FAQ_A2') },
    { q: t('FAQ_Q3'), a: t('FAQ_A3') },
    { q: t('FAQ_Q4'), a: t('FAQ_A4') },
    { q: t('FAQ_Q5'), a: t('FAQ_A5') },
    { q: t('FAQ_Q6'), a: t('FAQ_A6') },
    { q: t('FAQ_Q7'), a: t('FAQ_A7') },
    { q: t('FAQ_Q8'), a: t('FAQ_A8') },
    { q: t('FAQ_Q9'), a: t('FAQ_A9') },
    { q: t('FAQ_Q10'), a: t('FAQ_A10') },
    { q: t('FAQ_Q11'), a: t('FAQ_A11') },
    { q: t('FAQ_Q12'), a: t('FAQ_A12') },
    { q: t('FAQ_Q13'), a: t('FAQ_A13') },
    { q: t('FAQ_Q14'), a: t('FAQ_A14') },
    { q: t('FAQ_Q15'), a: t('FAQ_A15') },
    { q: t('FAQ_Q16'), a: t('FAQ_A16') },
    { q: t('FAQ_Q17'), a: t('FAQ_A17') },
    { q: t('FAQ_Q18'), a: t('FAQ_A18') },
    { q: t('FAQ_Q19'), a: t('FAQ_A19') },
    { q: t('FAQ_Q20'), a: t('FAQ_A20') },
    { q: t('FAQ_Q21'), a: t('FAQ_A21') },
    { q: t('FAQ_Q22'), a: t('FAQ_A22') },
    { q: t('FAQ_Q23'), a: t('FAQ_A23') },
    { q: t('FAQ_Q24'), a: t('FAQ_A24') }
  ]

  const toggle = (index) => {
    setOpenIndex(openIndex === index ? null : index)
  }

  return (
    <>
      <div
        onClick={onClose}
        style={footerModalOverlayStyle()}
      />

      <div
        style={footerModalBoxStyle({
          maxHeight: '80vh'
        })}
      >
        <div style={{ marginBottom: 12, fontWeight: 'bold', fontSize: 24 }}>
          {t('FAQ_TITLE')}
        </div>

        {faq.map((item, index) => (
          <div key={index} style={{ marginBottom: 12 }}>
            <div
              onClick={() => toggle(index)}
              style={{
                cursor: 'pointer',
                fontWeight: 'bold',
                fontSize: 14,
                display: 'flex',
                alignItems: 'center'
              }}
            >
              <span style={{ marginRight: 8 }}>
                {openIndex === index ? '▾' : '▸'}
              </span>
              {item.q}
            </div>

            {openIndex === index && (
              <div
                style={{
                  marginTop: 6,
                  marginLeft: 20,
                  fontSize: 14,
                  whiteSpace: 'pre-line'
                }}
              >
                {item.a}
              </div>
            )}
          </div>
        ))}

        <div style={footerModalActionsStyle}>
          <button
            onClick={onClose}
            style={primaryButtonStyle(
              pressedBtn,
              'faq-close',
              hoverBtn === 'faq-close'
            )}
            onMouseEnter={() => setHoverBtn('faq-close')}
            onMouseLeave={() => {
              setHoverBtn(null)
              setPressedBtn(null)
            }}
            onMouseDown={() => setPressedBtn('faq-close')}
            onMouseUp={() => setPressedBtn(null)}
          >
            {t('CLOSE')}
          </button>
        </div>
      </div>
    </>
  )
}

export default FaqModal